<template>
	<div class="panel" :class="[{show: show === true}, orientation]">
        <div class="inner">
            <slot></slot>
        </div>
	</div>
</template>
<script type="text/javascript">
	// import helper from './../helpers';

	export default {
		name: 'Panel',
		props: ['className', 'show', 'orientation'],
		data() {
			return {}
		},
        methods: {
            
        }
	}
</script>
<style scoped>
	.panel {
        position:fixed;
        top:0;
        z-index:10;
        overflow-x:hidden;
        overflow-y:scroll;
        -webkit-overflow-scrolling: auto;
        transition: all 400ms ease;
    }

    .panel > .inner {
        width: 100%;
        display: flex;
    }

    .panel.side {
        width: 25%;
        height: 100%;
        right:0;
        box-shadow:-10px 0px 12px -6px rgba(40,43,45,0.2);
    }

    .panel.side, .panel.side .panel {
        transform:translateX(100%);
    }

    .panel.side.show, .panel.side.show .panel {
        transform:translateX(0);
    }

    .panel.bottom {
        width: 100%;
        height: 90%;
        padding: 12px 0 0 0;
        border-radius: 20px 20px 0 0;
        top: 10%;
        left:0;
        box-shadow:0 -10px 12px -6px rgb(40 43 45 / 20%);
    }

    .panel.bottom, .panel.bottom .panel {
        transform:translateY(100%);
    }

    .panel.bottom.show, .panel.bottom.show .panel {
        transform:translateY(0);
    }

    .panel {
        width: 100%;
        background: #FFF;
        /* position: sticky; */
        top: 0;
        right: 0;
        transition: all 300ms ease;
        z-index: 10;
    }

    .panel.show .panel {
        transform: translateX(0);
    }

    .panel > * {
        transition: all 400ms ease;
    }

    .panel:not(.show) .panel > * {
        transform:translateX(100%);
        opacity: 0;
    }

    .panel.show > * {
        transform:translateX(0);
        opacity: 1;
    }
</style>